import { isDefined, numberOrZero } from "@/utils/utils";
import { Button, Popover } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatLocaleNumber } from "../../../../../../common/utils/formatUtils";
import { tInterval } from "../../../../../../common/utils/translationUtils";
import { DashboardGoalType } from "../../../../enums";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";
import { AddGoalModal } from "../modals/AddGoalModal";
import { isCreatedGoal } from "../utils";

type Props = {
  traineesGoal?: DashboardGoal;
  clientsGoal?: DashboardGoal;
  year: number;
  agentId: string;
};

export const BrokerTraineeClientsGoalWrapper = ({ traineesGoal, clientsGoal, agentId, year }: Props) => {
  const { t } = useTranslation();

  const [isOpenSetGoalModal, setIsOpenSetGoalModal] = useState(false);

  const traineesValue = numberOrZero(traineesGoal?.actualValue);
  const clientsValue = numberOrZero(clientsGoal?.actualValue);

  const hasTarget = isDefined(traineesGoal?.targetValue) || isDefined(clientsGoal?.targetValue);
  const mainGoal = traineesGoal?.id ? traineesGoal : clientsGoal;
  const actualValue = numberOrZero(mainGoal?.actualValue);

  const currentPercentage = isCreatedGoal(mainGoal)
    ? getPercentage(actualValue, numberOrZero(mainGoal.targetValue))
    : 0;

  return (
    <>
      <GoalCard
        goal={mainGoal}
        agentId={agentId}
        year={year}
        percentage={currentPercentage}
        label={
          hasTarget ? (
            <Popover
              content={
                mainGoal?.type === DashboardGoalType.BROKER_ALL_TRAINEES
                  ? t("dashboard.goals.helpers.traineesGoalHint")
                  : t("dashboard.goals.helpers.clientsGoalHint")
              }
            >
              {t(`dashboard.enums.dashboardGoalType.${mainGoal?.type ?? DashboardGoalType.BROKER_ALL_TRAINEES}`)}
            </Popover>
          ) : (
            <Button onClick={() => setIsOpenSetGoalModal(true)}>{t("dashboard.goals.actions.setTarget")}</Button>
          )
        }
        hasTarget={hasTarget}
        targetLabel={
          hasTarget ? undefined : (
            <div style={{ color: "white" }}>
              <span style={{ fontSize: 28 }}>{formatLocaleNumber(traineesValue)}</span>
              <div style={{ fontSize: 14, paddingTop: 4 }} className="margin-bottom-tiny">
                {tInterval("dashboard.goals.helpers.trainees_interval", traineesValue)}
              </div>

              <span style={{ fontSize: 28 }}>{formatLocaleNumber(clientsValue)}</span>
              <div style={{ fontSize: 14, paddingTop: 4 }}>
                {tInterval("dashboard.goals.helpers.clients_interval", clientsValue)}
              </div>
            </div>
          )
        }
        tooltipTitle={
          hasTarget ? (
            <p>
              {actualValue}{" "}
              {mainGoal?.type === DashboardGoalType.BROKER_ALL_TRAINEES
                ? tInterval("dashboard.goals.helpers.trainees_interval", actualValue)
                : tInterval("dashboard.goals.helpers.clients_interval", actualValue)}{" "}
              {t("dashboard.goals.helpers.from")} {mainGoal?.targetValue}
            </p>
          ) : undefined
        }
      />

      <AddGoalModal
        isOpen={isOpenSetGoalModal}
        onCancel={() => setIsOpenSetGoalModal(false)}
        goalTypeOptions={[DashboardGoalType.BROKER_ALL_TRAINEES, DashboardGoalType.BROKER_CLIENTS]}
        year={year}
        agentId={agentId}
      />
    </>
  );
};
